"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var useStyles = (0, _styles.makeStyles)({
  container: {
    flexGrow: 1,
    display: "flex",
    height: "calc(100% - 128px)",
    overflowY: "scroll",
    overflowX: "hidden",
    position: "relative"
  }
}, {
  name: "GgSidePageBody"
});
var SidePageBody = function SidePageBody(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.container,
    children: children
  });
};
var _default = exports["default"] = SidePageBody;